import ButtonTrigger from 'components/button-trigger';
import callbackCall from 'components/form/config/call';
import Form from 'components/form';
import Header from 'components/header';
import Observer from 'common/scripts/observer';
import PageReveal from 'components/page-reveal';
import Popup from 'components/popup';
import Select from 'components/forms/select';
import Utils from 'common/scripts/utils';

const observer = new Observer();

// Поведение шапки
export const initHeader = (headerWrap) => {
    const targetScroll = document.querySelector('.j-first-screen-bg') ||
        document.querySelector('.j-main-screen');
    const header = new Header();

    header.init({
        headerWrap,
        targetScroll
    });
};

// Поведение меню
export const initMobileMenu = (burgerMenuSelector, headerWrap) => {
    const menuTrigger = new ButtonTrigger();
    const mobileMenu = headerWrap.querySelector('.navigation-mobile');

    menuTrigger.init({
        target    : burgerMenuSelector,
        eventOpen : 'showMenuTrigger',
        eventClose: 'closeMenuTrigger'
    });

    observer.subscribe('showMenuTrigger', () => {
        headerWrap.classList.add('is-open-menu');
        Utils.bodyFixed(mobileMenu);
    });

    observer.subscribe('closeMenuTrigger', () => {
        headerWrap.classList.remove('is-open-menu');
        Utils.bodyStatic();
    });

    observer.subscribe('scrollbyStart', () => {
        headerWrap.classList.remove('is-open-menu');
        Utils.bodyStatic();
    });
};

// Попапы обратной связи
export const initCallbackPopups = (popupLinks) => {
    const popupOptions = {
        openButtons         : popupLinks,
        closeButtonAriaLabel: 'Закрыть форму обратной связи',
        template            : 'classic',
        templateContent     : 'action',
        openLoadPage        : false
    };

    const popupCallback = new Popup(popupOptions);

    popupCallback.init();
};

// Инициализация формы обратной связи
export const initCallbackForm = () => {
    observer.subscribe('createPopup', (popup, instance) => {
        if (!popup) {
            return;
        }

        const callbackSelector = popup.querySelector('.j-form-callback');

        if (callbackSelector) {
            if (window.sessionStorage.getItem('callback-init') === null) {
                window.sessionStorage.setItem('callback-init', 'true');
            } else {
                return;
            }

            const form = new Form();
            const select = new Select();
            const callbackSelect = callbackSelector.querySelector('.j-select');

            if (callbackSelect) {
                select.init({
                    element      : callbackSelect,
                    disableSearch: true
                });
            }

            callbackCall(form, callbackSelector, instance);

            observer.subscribe('successForm', () => {
                // Закрываем попап через 3сек
                const send = setTimeout(() => {
                    observer.publish('sendForm', instance);
                }, 3000);

                // Если попап был закрыт ранее через кнопку, то обнуляем интервал.
                observer.subscribe('closePopup', () => {
                    clearTimeout(send);
                });
            });
        }
    });
};

// При открытии попапа сдвигаем шапку на ширину сколл-бара.
export const fixPopupHeader = (headerWrap) => {
    if (!headerWrap) {
        return;
    }

    observer.subscribe('showPopup', () => {
        const body = document.body;

        setTimeout(() => {
            headerWrap.style.paddingRight = getComputedStyle(body).paddingRight;
        });
    });

    observer.subscribe('closePopup', () => {
        headerWrap.style.paddingRight = '0';
    });
};

// Анимация появления блоков
export const initPageReveal = (options) => {
    new PageReveal().init(options);
};

// Подключение ленивой загрузки (img/picture/iframe)
// export const lazyLoadElements = (lazyElements) => {
//     const replaceSource = (element) => {
//         const targetAttribute = element.nodeName === 'SOURCE' ? 'srcset' : 'src';
//         const sourceElement = element.nodeName === 'SOURCE' ? 'data-srcset' : 'data-src';
//
//         if (element.getAttribute(sourceElement)) {
//             element.setAttribute(targetAttribute, element.getAttribute(sourceElement));
//             element.removeAttribute(sourceElement);
//         }
//     };
//
//     if ('IntersectionObserver' in window) {
//         const lazyImageObserver = new IntersectionObserver((entries) => {
//             entries.forEach((entry) => {
//                 if (entry.isIntersecting) {
//                     const lazyEl = entry.target;
//                     console.log(lazyEl)
//
//                     replaceSource(lazyEl);
//                     lazyImageObserver.unobserve(lazyEl);
//                 }
//             });
//         });
//
//         lazyElements.forEach((lazyImage) => {
//             if (Utils.isInViewport(lazyImage, window.innerHeight || document.documentElement.clientHeight)) {
//                 replaceSource(lazyImage);
//             } else {
//                 lazyImageObserver.observe(lazyImage);
//             }
//         });
//     } else {
//         // Not supported or native support, load all images immediately
//         lazyElements.forEach((lazyEl) => {
//             replaceSource(lazyEl);
//         });
//     }
// };
